import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface ICustomerDetailReport_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ICustomerDetailReport_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  Boss_VCustomerDetail: any[];
  Boss_VCustomerDetail_dummy: any[];
  Boss_VCustomerDetailTotal: any[];
  Boss_VCustomerDetailTotal_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class CustomerDetailReport_ScreenBase extends React.PureComponent<
  ICustomerDetailReport_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  customerdetailreport_595262_value_kuikaSelectBoxRef: React.RefObject<any>;
  customerdetailreport_576431_value_kuikaTableRef: React.RefObject<any>;
  customerdetailreport_757447_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "19fd5f36-4187-4ce3-adde-794abef09355",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 441998, PropertyName: "value", Value: "Ekstre Detay" },
        { Id: 76936, PropertyName: "value", Value: "Para Birimi" },
        { Id: 87090, PropertyName: "value", Value: "Net Varlık" },
        { Id: 526116, PropertyName: "value", Value: "label" },
        { Id: 627875, PropertyName: "value", Value: "Zaman Aralığı" },
        { Id: 595262, PropertyName: "placeholder", Value: "Tümü" },
        { Id: 963635, PropertyName: "title", Value: "Title" },
        { Id: 677131, PropertyName: "value", Value: "[datafield:gun]" },
        { Id: 584716, PropertyName: "value", Value: "[datafield:ay]" },
        { Id: 966227, PropertyName: "value", Value: "[datafield:belgeno]" },
        { Id: 337898, PropertyName: "value", Value: "[datafield:aciklama]" },
        { Id: 317720, PropertyName: "value", Value: "[datafield:belgetipi]" },
        { Id: 761109, PropertyName: "value", Value: "[datafield:tutar]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.customerdetailreport_595262_value_kuikaSelectBoxRef =
      React.createRef();
    this.customerdetailreport_576431_value_kuikaTableRef = React.createRef();
    this.customerdetailreport_757447_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      Boss_VCustomerDetail: [],
      Boss_VCustomerDetailTotal: [],
      SetValueOf: "",
      dataSource_595262: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "customerdetailreport",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.CustomerDetailReportPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.CustomerDetailReportPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "customerdetailreport",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "customerdetailreport",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.CustomerDetailReportPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.CustomerDetailReportPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  CustomerDetailReportPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      DateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      CustomerCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CustomerDetailReport/CustomerDetailReportPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomerDetail = result?.data.boss_VCustomerDetail;

    stateVars.Boss_VCustomerDetailTotal =
      result?.data.boss_VCustomerDetailTotal;
    formVars.customerdetailreport_705181_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].currencyCode
        : null
    );
    formVars.customerdetailreport_526116_maxline =
      ReactSystemFunctions.toInteger(
        this,
        stateVars.Boss_VCustomerDetailTotal !== undefined
          ? stateVars.Boss_VCustomerDetailTotal?.length > 0
            ? stateVars.Boss_VCustomerDetailTotal[0].tutar
            : null
          : this.state.Boss_VCustomerDetailTotal?.length > 0
          ? this.state.Boss_VCustomerDetailTotal[0].tutar
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.CustomerDetailReportPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CustomerDetailReportPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.customerdetailreport_705181_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].currencyCode
        : null
    );

    formVars.customerdetailreport_526116_maxLine =
      ReactSystemFunctions.toInteger(
        this,
        stateVars.Boss_VCustomerDetailTotal !== undefined
          ? stateVars.Boss_VCustomerDetailTotal?.length > 0
            ? stateVars.Boss_VCustomerDetailTotal[0].tutar
            : null
          : this.state.Boss_VCustomerDetailTotal?.length > 0
          ? this.state.Boss_VCustomerDetailTotal[0].tutar
          : null
      );

    stateVars.dataSource_576431 =
      stateVars.Boss_VCustomerDetail ?? this.state.Boss_VCustomerDetail;
    formVars.customerdetailreport_757447_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].totalCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].totalCount
        : null
    );
    formVars.customerdetailreport_757447_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].pageCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].pageCount
        : null
    );

    formVars.customerdetailreport_757447_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].totalCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].totalCount
        : null
    );
    formVars.customerdetailreport_757447_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].pageCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  CustomerDetailReportComponent_163173_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CustomerDetailReportComponent_595262_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "customerdetailreport_595262_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      DateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "customerdetailreport_595262_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CustomerDetailReport/CustomerDetailReportComponent_595262_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomerDetail = result?.data.boss_VCustomerDetail;

    stateVars.Boss_VCustomerDetailTotal =
      result?.data.boss_VCustomerDetailTotal;
    formVars.customerdetailreport_705181_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].currencyCode
        : null
    );
    formVars.customerdetailreport_526116_maxline =
      ReactSystemFunctions.toInteger(
        this,
        stateVars.Boss_VCustomerDetailTotal !== undefined
          ? stateVars.Boss_VCustomerDetailTotal?.length > 0
            ? stateVars.Boss_VCustomerDetailTotal[0].tutar
            : null
          : this.state.Boss_VCustomerDetailTotal?.length > 0
          ? this.state.Boss_VCustomerDetailTotal[0].tutar
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CustomerDetailReportComponent_595262_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CustomerDetailReportComponent_595262_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "customerdetailreport_757447_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.customerdetailreport_705181_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].currencyCode
        : null
    );

    formVars.customerdetailreport_526116_maxLine =
      ReactSystemFunctions.toInteger(
        this,
        stateVars.Boss_VCustomerDetailTotal !== undefined
          ? stateVars.Boss_VCustomerDetailTotal?.length > 0
            ? stateVars.Boss_VCustomerDetailTotal[0].tutar
            : null
          : this.state.Boss_VCustomerDetailTotal?.length > 0
          ? this.state.Boss_VCustomerDetailTotal[0].tutar
          : null
      );

    stateVars.dataSource_576431 =
      stateVars.Boss_VCustomerDetail ?? this.state.Boss_VCustomerDetail;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CustomerDetailReportComponent_757447_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "customerdetailreport_595262_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "customerdetailreport_757447_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CustomerDetailReport/CustomerDetailReportComponent_757447_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomerDetail = result?.data.boss_VCustomerDetail;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CustomerDetailReportComponent_757447_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CustomerDetailReportComponent_757447_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_576431 =
      stateVars.Boss_VCustomerDetail ?? this.state.Boss_VCustomerDetail;
    formVars.customerdetailreport_757447_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].totalCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].totalCount
        : null
    );
    formVars.customerdetailreport_757447_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].pageCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].pageCount
        : null
    );

    formVars.customerdetailreport_757447_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].totalCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].totalCount
        : null
    );
    formVars.customerdetailreport_757447_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].pageCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.CustomerDetailReportPageInit();
    }
  }
}
